import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'icon-info-yellow',
  templateUrl: './icon-info-yellow.component.html',
  styles: []
})
export class IconInfoYellowComponent implements OnInit {
  constructor() {}

  ngOnInit() {}
}
